module.exports = __webpack_public_path__ + "static/media/ico-new-premios.357aac5d.svg";